import { formatAmountINR } from "../../../../../shared/utils/amountFormat";

export const getTextFields = (studentData: any) => {
  const studentClass = studentData?.studentClass?.[0];
  const classInfo = studentClass?.class;
  const academicYear = studentClass?.academicYear;
  // const feeTerms = classInfo?.fee?.feeTerms || [];

  return [
    {
      id: "student-name",
      name: "name",
      label: "Name",
      type: "text",
      placeholder: "Enter Full Name",
      required: true,
      capitalizedFirst: true,
      value: studentData?.name || "",
    },
    {
      id: "admission-number",
      name: "admissionNumber",
      label: "Admission Number",
      type: "text",
      value: studentData?.admissionNumber || "-",
    },
    {
      id: "class-name",
      name: "class",
      label: "Class",
      type: "text",
      value: classInfo?.name || "-",
    },
    {
      id: "division",
      name: "division",
      label: "Division",
      type: "text",
      value: studentClass?.division || "-",
    },
    {
      id: "roll-number",
      name: "rollNumber",
      label: "Roll Number",
      type: "text",
      value: studentClass?.rollNumber || "-",
    },
    {
      id: "academic-year",
      name: "academicYear",
      label: "Academic Year",
      type: "text",
      value: academicYear?.name || "-",
    },
    {
      id: "total-fee",
      name: "totalFee",
      label: "Total Fee",
      type: "text",
      value: formatAmountINR(classInfo?.fee?.totalFee) || "-",
    },
    // ...feeTerms.map((term: any) => ({
    //   id: `term-${term.id}`,
    //   name: term.name,
    //   label: `Fee - ${term.name}`,
    //   type: "text",
    //   value: formatAmountINR(term.amount),
    // })),    
  ];
};